function moveElementsProductblock() {
  if (!document.body.classList.contains('template-product')) return;

  if (window.matchMedia("(max-width: 788px)").matches) {
    var instaMob = document.querySelector('#shopify-block-AdXN3bkRObmIxbjFuN__instafeed_app_block_MxjTiW');
    var imageBlockMob = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    if (instaMob && imageBlockMob && !imageBlockMob.contains(instaMob)) {
      imageBlockMob.appendChild(instaMob);
    }

    var reviewsMob = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    var productDescMob = document.querySelector('.productdescription');
    if (reviewsMob && productDescMob && !productDescMob.contains(reviewsMob)) {
      productDescMob.appendChild(reviewsMob);
    }

   var reviewsArchiveMobiel = document.querySelector('#shopify-section-template--24672860864842__custom_liquid_nfbckQ');
   var galleryArchiveMobiel = document.querySelector('.productdescription');
    if (reviewsArchiveMobiel && galleryArchiveMobiel && !galleryArchiveMobiel.contains(reviewsArchiveMobiel)) {
      galleryArchiveMobiel.appendChild(reviewsArchiveMobiel);
    }
  }

  if (window.matchMedia("(min-width: 789px)").matches) {
    var instaProductblock = document.querySelector('#shopify-block-AdXN3bkRObmIxbjFuN__instafeed_app_block_MxjTiW');
    var imageProductblok = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    if (instaProductblock && imageProductblok && !imageProductblok.contains(instaProductblock)) {
      imageProductblok.appendChild(instaProductblock);
    }

    var reviewsProductblock = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    var galleryProductblock = document.querySelector('.gallery');
    if (reviewsProductblock && galleryProductblock && !galleryProductblock.contains(reviewsProductblock)) {
      galleryProductblock.appendChild(reviewsProductblock);
    }

   var reviewsArchive = document.querySelector('#shopify-section-template--24672860864842__custom_liquid_nfbckQ');
   var galleryArchive = document.querySelector('.gallery');
    if (reviewsArchive && galleryArchive && !galleryArchive.contains(reviewsArchive)) {
      galleryArchive.appendChild(reviewsArchive);
    }
  }

  var reviewBlockOptieTwee = document.querySelector('.reviewblokproduct');
  var mainImageOptieTwee = document.querySelector('.main-image');
  if (reviewBlockOptieTwee && mainImageOptieTwee && !mainImageOptieTwee.contains(reviewBlockOptieTwee)) {
    mainImageOptieTwee.appendChild(reviewBlockOptieTwee);
  }

  var accordionProductblock = document.querySelector('.not-in-quickbuy.product-detail-accordion');
  var productDescProductblock = document.querySelector('.productdescription');
  if (accordionProductblock && productDescProductblock && !productDescProductblock.contains(accordionProductblock)) {
    productDescProductblock.appendChild(accordionProductblock);
  }
}

document.addEventListener('DOMContentLoaded', moveElementsProductblock);

setTimeout(moveElementsProductblock, 1000);
setTimeout(moveElementsProductblock, 3000);


var intervalproductForm = setInterval(function() {
    var productForm = document.querySelector('.product-form');
    if (!productForm) return;

    var labelsproductForm = productForm.querySelectorAll('.label');
    if (!labelsproductForm.length) return;

    var changedproductForm = false;

    for (var i = 0; i < labelsproductForm.length; i++) {
      var text = labelsproductForm[i].textContent.trim();

      if (text === 'Color') {
        labelsproductForm[i].textContent = 'Choose your color';
        changedproductForm = true;
      } else if (text === 'Kleur') {
        labelsproductForm[i].textContent = 'Kies je kleur';
        changedproductForm = true;
      } else if (text === 'Size') {
        labelsproductForm[i].textContent = 'Choose your size';
        changedproductForm = true;
      } else if (text === 'Maat') {
        labelsproductForm[i].textContent = 'Kies je maat';
        changedproductForm = true;
      }
    }

    // Stop zodra alles is aangepast
    if (changedproductForm) {
      clearInterval(intervalproductForm);
    }
  }, 300);

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.product-form')) {
    checkOnDemand();
  }
});

function checkOnDemand() {
  var optionSelectors = document.querySelectorAll('.option-selectors');
  if (!optionSelectors.length) {
    checkOnDemandSwatch();
    return;
  }

  for (var i = 0; i < optionSelectors.length; i++) {
    var optionSelector = optionSelectors[i];

    // Check if on-demand option is selected initially on Size
    var selectedOnDemand = optionSelector.querySelector('.opt-btn.on-demand[checked]');
    if (selectedOnDemand) {
      optionSelector.classList.remove('on-demand-not-selected');
      optionSelector.classList.add('on-demand-selected');
    } else {
      optionSelector.classList.remove('on-demand-selected');
      optionSelector.classList.add('on-demand-not-selected');
    }

    // Add click handlers for all option buttons
    var optButtons = optionSelector.querySelectorAll('.opt-btn');

    optButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var parentSelector = this.closest('.option-selectors');
        if (parentSelector) {
          if (this.classList.contains('on-demand')) {
            parentSelector.classList.remove('on-demand-not-selected');
            parentSelector.classList.add('on-demand-selected');
          } else {
            parentSelector.classList.remove('on-demand-selected');
            parentSelector.classList.add('on-demand-not-selected');
          }
        }
      });
    });
  }
}

function checkOnDemandSwatch() {
  var swatchSelectors = document.querySelectorAll('.product-colours');
  if (!swatchSelectors.length) {
    checkOnDemandForm();
    return;
  }

  for (var i = 0; i < swatchSelectors.length; i++) {
    var swatchSelector = swatchSelectors[i];

    var selectedOnDemand = swatchSelector.querySelector('.swatches-pdp.on-demand-swatch');
    if (selectedOnDemand) {
      swatchSelector.classList.remove('swatches-not-on-demand');
      swatchSelector.classList.add('swatches-on-demand');
    } else {
      swatchSelector.classList.remove('swatches-on-demand');
      swatchSelector.classList.add('swatches-not-on-demand');
    }
  }
}

function checkOnDemandForm() {
  var theForm = document.querySelector('.product-form');

  var isOnDemand = theForm.dataset.productOnDemand === 'true';
  if (isOnDemand) {
    theForm.classList.add('product-form-on-demand');
  } else {
    theForm.classList.add('product-form-not-on-demand');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  (function() {
    const indicators = document.querySelectorAll('.on-demand-update__indicator');
    indicators.forEach(function(indicator) {
      const tooltip = indicator.querySelectorAll('.on-demand-update__tooltip-text');
      if (!tooltip) return;
      
      tooltip.forEach(function(tooltip) {
        indicator.addEventListener('mouseenter', function() {
          tooltip.classList.add('tooltip-displayed');

          // Reset everything to default state first
          tooltip.classList.remove('tooltip-right', 'tooltip-left');
          tooltip.style.transform = '';
          
          // Show tooltip to measure it
          tooltip.style.visibility = 'visible';
          tooltip.style.opacity = '1';
          tooltip.style.display = 'block';
          
          // Use requestAnimationFrame to ensure tooltip is rendered before measuring
          requestAnimationFrame(function() {
            const tooltipRect = tooltip.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const margin = 10; // Minimum distance from edge
            
            // Check if tooltip overflows right edge
            if (tooltipRect.right > viewportWidth - margin) {
              tooltip.classList.add('tooltip-right');
              
              // Re-measure after class change
              requestAnimationFrame(function() {
                const newTooltipRect = tooltip.getBoundingClientRect();
                if (newTooltipRect.right > viewportWidth - margin) {
                  const overflow = newTooltipRect.right - (viewportWidth - margin);
                  tooltip.style.transform = `translateX(-${overflow}px)`;
                }
              });
            }
            // Check if tooltip overflows left edge
            else if (tooltipRect.left < margin) {
              tooltip.classList.add('tooltip-left');
              
              // Re-measure after class change
              requestAnimationFrame(function() {
                const newTooltipRect = tooltip.getBoundingClientRect();
                if (newTooltipRect.left < margin) {
                  const overflow = margin - newTooltipRect.left;
                  tooltip.style.transform = `translateX(${overflow}px)`;
                }
              });
            }

            
            tooltip.style.maxWidth = '288px';
          });
        });
        
        indicator.addEventListener('mouseleave', function() {
          tooltip.classList.remove('tooltip-displayed');
          // Reset everything on mouseleave
          tooltip.classList.remove('tooltip-right', 'tooltip-left');
          tooltip.style.transform = '';
          tooltip.style.visibility = 'hidden';
          tooltip.style.opacity = '0';
          tooltip.style.display = 'none';
          tooltip.style.maxWidth = 'unset';
        });
      });
    });
  })();
});